import { DIALOG_CANCEL_LABEL, DIALOG_CONFIRM_LABEL } from "./messages";
import type { DialogFooterProps, DialogFooterViewModel } from "./types-dialog-footer";

/** ViewModel do DialogFooter: props de cada botão (rótulo, variante, `data-testid`, bloqueio) sob as props de botão da tela; sem JSX. */
export function useDialogFooter({
  testId,
  cancelTestId,
  confirmTestId,
  cancelLabel = DIALOG_CANCEL_LABEL,
  confirmLabel = DIALOG_CONFIRM_LABEL,
  onCancel,
  onConfirm,
  extraLabel,
  onExtra,
  extraTestId,
  extraClassName,
  extraButtonProps,
  formId,
  stackOnMobile = false,
  locked = false,
  loading = false,
  severity,
  cancelVariant = "solid",
  cancelClassName,
  confirmClassName,
  cancelButtonProps,
  confirmButtonProps,
  className,
  ...rest
}: DialogFooterProps): DialogFooterViewModel {
  return {
    extraProps:
      extraLabel === undefined
        ? null
        : {
            type: "button",
            label: extraLabel,
            severity: "secondary",
            onClick: onExtra,
            className: extraClassName,
            "data-testid": extraTestId ?? (testId ? `${testId}-extra` : undefined),
            ...extraButtonProps,
            disabled: locked || extraButtonProps?.disabled,
          },
    className,
    empilhado: stackOnMobile,
    rest,
    cancelProps: {
      type: "button",
      label: cancelLabel,
      text: cancelVariant === "text",
      outlined: cancelVariant === "outlined",
      severity: "secondary",
      onClick: onCancel,
      className: cancelClassName,
      "data-testid": cancelTestId ?? (testId ? `${testId}-cancel` : undefined),
      ...cancelButtonProps,
      disabled: locked || cancelButtonProps?.disabled,
    },
    confirmProps: {
      type: formId ? "submit" : "button",
      form: formId,
      label: confirmLabel,
      severity: severity === "danger" ? "danger" : undefined,
      loading,
      onClick: onConfirm,
      className: confirmClassName,
      "data-testid": confirmTestId ?? (testId ? `${testId}-confirm` : undefined),
      ...confirmButtonProps,
    },
  };
}
